export const formatAmount = (num)  => {
  const roundedNum = Math.ceil(num);

  const formattedNumber = roundedNum
    .toString()
    .replace(/\B(?=(\d{3})+(?!\d))/g, ',');

  return formattedNumber;
};